function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import { PageContainer, useSsr } from "@pochta/ui";
import isActiveUrl from "../../../../../../helpers/isActiveUrl";
import { NOT_FOUND } from "../../constants";
import { MenuBox, MenuItems, MenuItem, Underline } from "./Menu.styles";
import { BorderedBox } from "../../Header.styles";

/**
 * Создает функцию которая может вычислять ширину текущего элемента и его положение относительно текущего меню
 * @param menuItemsRef список элементов
 */
export var getMenuItemStyledSetting = function getMenuItemStyledSetting(menuItemsRef) {
  return function (index) {
    var current = menuItemsRef.current[index];

    if (typeof index === "number" && current) {
      var _menuItemsRef$current = menuItemsRef.current[0].getBoundingClientRect(),
          firstLeft = _menuItemsRef$current.left;

      var _current$getBoundingC = current.getBoundingClientRect(),
          width = _current$getBoundingC.width,
          left = _current$getBoundingC.left;

      return {
        width: Math.ceil(width),
        left: left - firstLeft,
        translate: false
      };
    }

    return {
      width: 0,
      left: 0,
      translate: false
    };
  };
};

var Menu = function Menu(_ref) {
  var _ref$menu = _ref.menu,
      menu = _ref$menu === void 0 ? {} : _ref$menu,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? NOT_FOUND : _ref$active,
      onChangeActive = _ref.onChangeActive,
      setMenuItems = _ref.setMenuItems,
      isFluid = _ref.isFluid,
      pageContainerMaxWidth = _ref.pageContainerMaxWidth;
  var isFirstLoad = useRef(true);
  var underlineRef = useRef(null);
  var _menu$items = menu.items,
      items = _menu$items === void 0 ? [] : _menu$items;
  var menuItemsRef = useRef([]);
  var getMenuItemStyled = getMenuItemStyledSetting(menuItemsRef);

  var _useState = useState(getMenuItemStyled()),
      _useState2 = _slicedToArray(_useState, 2),
      styles = _useState2[0],
      setStyles = _useState2[1];

  var _useSsr = useSsr(),
      isSsr = _useSsr.isSsr;

  var currentIndexItem = useMemo(function () {
    // TODO оптимизировать isActiveUrl для сервер сайд рендеринга
    if (isSsr) return null;
    return items.map(function (_ref2, index) {
      var subItems = _ref2.items,
          link = _ref2.link;
      return ((subItems === null || subItems === void 0 ? void 0 : subItems.length) > 0 ? subItems.find(function (item) {
        return isActiveUrl(item.link);
      }) : isActiveUrl(link)) && index;
    }, []).find(function (index) {
      return typeof index === "number";
    });
  }, [items, isSsr]);
  var underlined = useMemo(function () {
    if (active !== NOT_FOUND) {
      return active;
    }

    return typeof currentIndexItem === "number" ? currentIndexItem : NOT_FOUND;
  }, [active, currentIndexItem]);
  useEffect(function () {
    if (underlined > -1 && menuItemsRef.current[underlined]) {
      var setPositions = function setPositions() {
        var _getMenuItemStyled = getMenuItemStyled(underlined),
            width = _getMenuItemStyled.width,
            left = _getMenuItemStyled.left;

        setStyles(_objectSpread(_objectSpread({}, styles), {}, {
          width: width,
          left: left,
          translate: !isFirstLoad.current
        }));
      };

      if (isFirstLoad.current) {
        // При первом рендере не правильно считается left и width
        // высчитываем после рендера
        setTimeout(setPositions, 0);
        isFirstLoad.current = false;
      } else {
        setPositions();
      }
    }
  }, [underlined]);
  return /*#__PURE__*/React.createElement(MenuBox, {
    as: BorderedBox
  }, /*#__PURE__*/React.createElement(PageContainer, {
    fluid: isFluid,
    limitMaxWidthBreakpoint: pageContainerMaxWidth
  }, /*#__PURE__*/React.createElement(MenuItems, null, items.map(function (_ref3, index) {
    var title = _ref3.title,
        link = _ref3.link,
        _ref3$items = _ref3.items,
        subItems = _ref3$items === void 0 ? [] : _ref3$items;
    return /*#__PURE__*/React.createElement(MenuItem, {
      ref: function ref(_ref4) {
        if (_ref4 && !menuItemsRef.current.includes(_ref4)) {
          menuItemsRef.current.push(_ref4);
        }
      },
      active: currentIndexItem === index,
      size: "m",
      href: subItems.length === 0 ? link : "#",
      key: title,
      onClick: function onClick(event) {
        if (subItems.length > 0) {
          event.preventDefault();
        }
      },
      onMouseEnter: function onMouseEnter() {
        setMenuItems(menuItemsRef.current);
        onChangeActive(index);
      },
      onFocus: function onFocus() {
        setMenuItems(menuItemsRef.current);
        onChangeActive(index);
      },
      "data-submenu": "submenu"
    }, title);
  }), (underlined > NOT_FOUND || currentIndexItem > NOT_FOUND) && /*#__PURE__*/React.createElement(Underline, {
    ref: underlineRef,
    width: styles.width,
    leftTransition: styles.left,
    transition: styles.translate,
    "data-submenu": "submenu"
  }))));
};

export default /*#__PURE__*/memo(Menu);